import { forwardRef } from 'react';

import { IconButton, OutlineCopy1 } from '../../vendor/ui';
import { copyToClipboard } from '../../utils/common';

import {
  Left,
  PriceEmail,
  PricePhone,
  PriceText,
  PriceTitle,
  Right,
  Wrapper,
} from './styled';

const EMAIL = 'zaur@aplosoft.ru';
const PHONE_NUMBER = '+7 905 536 09 78';

export const PriceBlock = forwardRef<HTMLDivElement>(() => {
  return (
    <Wrapper>
      <Left>
        <PriceTitle>Расчет стоимости и получение лицензии</PriceTitle>

        <PriceText>
          Программное обеспечение предоставляется по лицензии.
          Стоимость рассчитывается индивидуально в зависимости от количества устройств.
          <br />
          <br />
          Для получения лицензии и коммерческого предложения свяжитесь с нами
          по указанным контактам.
        </PriceText>
      </Left>

      <Right>
        <PriceEmail href={`mailto:${EMAIL}`}>
          {EMAIL}
        </PriceEmail>

        <PricePhone>
          {PHONE_NUMBER}
          <IconButton
            size="small"
            onClick={e => {
              e.stopPropagation();
              copyToClipboard(
                PHONE_NUMBER,
                `Номер телефона скопирован: ${PHONE_NUMBER}`
              );
            }}
            icon={<OutlineCopy1 />}
          />
        </PricePhone>
      </Right>
    </Wrapper>
  );
});
